// Import dependencies
import { setupCache } from 'axios-cache-interceptor';
import Axios from 'axios';

// Create `axios` instance with caching
export const api = setupCache(Axios.create(), {
  ttl: 15 * 60 * 1000,
});